import { createStore, applyMiddleware, combineReducers } from 'redux';
import logger from 'redux-logger';
import promise from 'redux-promise-middleware';
import access from './reducers/access';
import tenants from './reducers/tenants';
import surveys from './reducers/surveys';
import upload from './reducers/upload';
import charts from './reducers/charts';
import configs from './reducers/configs';
import simpleCross from './reducers/simpleCross';
import evolutive from './reducers/evolutive';
import alternatives from './reducers/alternatives';
import management from './reducers/management';
import annotations from './reducers/annotations';
import recoverPassword from './reducers/recoverPassword';
import report from './reducers/report';
import activeSurvey from './reducers/activeSurvey';
import authorizationGuard from './reducers/authorizationGuard/authorizationGuard';
import chartExporting from './reducers/chartExporting';
import consolidation from './reducers/consolidation';
import evolutiveCross from './reducers/evolutiveCross';

// reducers (executors)
const executors = combineReducers({
  access,
  tenants,
  surveys,
  alternatives,
  upload,
  charts,
  configs,
  simpleCross,
  evolutive,
  management,
  annotations,
  recoverPassword,
  report,
  activeSurvey,
  authorizationGuard,
  chartExporting,
  consolidation,
  evolutiveCross,
});

/**
 * Middleware que adiciona meta dados sobre quando a action foi lancada,
 * definindo qual cliente, pesquisa e pergunta estava selecionada no
 * momento do despacho da action
 */
const activeSurveyToActionMetaMiddleware = (store) => (next) => (action) => {
  if (!action.meta) action.meta = {};

  const { activeSurvey } = store.getState();

  if (!action.meta.clientIdOnDispatch || !action.meta.surveyIdOnDispatch || !action.meta.questionIdOnDispatch) {
    action.meta.clientIdOnDispatch = activeSurvey.client ? activeSurvey.client.id : null;
    action.meta.surveyIdOnDispatch = activeSurvey.survey ? activeSurvey.survey.id : null;
    action.meta.questionIdOnDispatch = activeSurvey.question ? activeSurvey.question.id : null;
  }

  next(action);
};

/**
 * Todos os dados do sistema sao recuperados de forma assincrona
 * e esses dados só são consistentes caso eles se refiram
 * ao cliente/pesquisa/pergunta que estao selecionados atualmente.
 *
 * Assim sendo, esta funcao verifica se a action recebida se refere
 * ao mesmo cliente/pesquisa/pergunta que estao selecionados no momento
 * em que a action chegou na store
 */
const canActionExecuteMiddleware = (store) => (next) => (action) => {
  const { activeSurvey } = store.getState();

  const currentClient = activeSurvey.client ? activeSurvey.client.id : null;
  const currentSurvey = activeSurvey.survey ? activeSurvey.survey.id : null;
  const currentQuestion = activeSurvey.question ? activeSurvey.question.id : null;

  const resultFromActiveSurvey = currentClient === action.meta.clientIdOnDispatch
    && currentSurvey === action.meta.surveyIdOnDispatch
    && currentQuestion === action.meta.questionIdOnDispatch;

  if (resultFromActiveSurvey) {
    next(action);
  }
};

// store
const middleware = applyMiddleware(activeSurveyToActionMetaMiddleware, canActionExecuteMiddleware, promise, logger);
const store = createStore(executors, middleware);

export default store;
